<template>
  <fragment>
    <v-col cols="12" md="4" class="pr-md-5">
      <BaseFormAutocompleteSelectable
        id-element="comercialEconomicGroup"
        placeholder="Selecione"
        v-model="value.responsavel_comercial"
        :items="comercialList"
        required
        :rules="[requiredInput]"
        label-text="Responsável Lockton (Comercial)"
        item-text="nome"
        item-value="id"
        :return-object="true"
        clearable
      />
    </v-col>
    <v-col cols="12" md="4">
      <BaseFormAutocompleteSelectable
        id-element="attendantEconomicGroup"
        placeholder="Selecione"
        v-model="value.atendentes"
        :items="atendentList"
        required
        :rules="[requiredInput]"
        label-text="Responsável Lockton (Atendente)"
        item-text="nome"
        item-value="id"
        :return-object="true"
        :multiple="true"
        clearable
      />
    </v-col>
    <v-col cols="12" md="4" class="pl-md-5">
      <BaseFormAutocompleteSelectable
        id-element="groupProductionEconomicGroup"
        placeholder="Selecione"
        v-model="value.grupo_operacao"
        :items="productList"
        required
        :rules="[requiredInput]"
        label-text="Grupo de Produção"
        item-text="nome"
        item-value="id"
        :return-object="true"
        clearable
      />
    </v-col>
  </fragment>
</template>

<script>
import { requiredInput } from "@/utils/rules.js";
export default {
  name: "AnswerDetails",
  props: {
    value: Object,
    atendentList: Array,
    comercialList: Array,
    productList: Array
  },
  data: () => ({
    requiredInput,
    timeout: null
  }),
  methods: {
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          const payload =
            value.target.id == "groupProductionEconomicGroup"
              ? `?query=${value.target.value}`
              : `?query=${value.target.value}&estrutura_id=funcionario`;
          let list =
            value.target.id == "comercialEconomicGroup"
              ? "comercialList"
              : value.target.id == "groupProductionEconomicGroup"
              ? "productList"
              : "atendentList";
          vm.$emit("search-users", payload, list);
          vm.timeout = null;
        }, 500);
    }
  }
};
</script>
